import { render } from "./FaqListSingle.vue?vue&type=template&id=46fb0281"
import script from "./FaqListSingle.vue?vue&type=script&lang=js"
export * from "./FaqListSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__